
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm.js'
import solutionsA from '~/components/Templates/Solutions/SolutionsA.vue'
import solutionsB from '~/components/Templates/Solutions/SolutionsB.vue'
import solutions from '~/components/Templates/Solutions/Solutions.vue'

export default {
  mixins: [gtm],
  nuxtI18n: {
    parsePages: true,
    locales: ['pt-br', 'en', 'es', 'es-mx', 'es-co', 'es-es', 'fr', 'ja', 'it'],
  },
  components: {
    solutionsA,
    solutionsB,
    solutions,
  },

  data() {
    return {
      // GTM
      gtmSubsection: 'Solutions',
      gtmSubsection2: '',
      // SEO
      title: this.$t('seo.solutions.title'),
      description: this.$t('seo.solutions.description'),
      url: `${process.env.BASE_URL}${this.$route.path}`,
      locale: this.$i18n.locales.find(l => l.code === this.$i18n.locale).iso,
      routeName: this.$route.name,
      orgSchema: { description: this.$t('seo.solutions.description'), ...this.$t('seo.organization') },
    }
  },

  head() {
    const basePayload = {
      title: this.title,
      description: this.description,
      url: this.url,
      locale: this.locale,
      routeName: this.routeName,
    }

    return {
      ...Provider.head.useComposeHeadTag({
        ...basePayload,
        schema: [
          { ...Provider.head.setSchemaOrganization({ ...this.orgSchema }) },
          { ...Provider.head.setSchemaWebpage({ ...basePayload }) },
          { ...Provider.head.setSchemaBreadcrumb({ breadcrumbs: this.breadcrumbs }) },
        ],
        meta: {},
        script: [],
        link: [],
      }),
    }
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
